<template>
  <layouts></layouts>
  <student-breadcrumb :title="title" :text="text" :text1="text1" />

  <div class="page-content course-sec">
    <div class="container">
      <div class="row align-items-center" style="margin-top: 50px;">
        <div class="col-md-12">
          <div class="add-course-header">
            <h2>Gestão de Usuários</h2>
            <div class="add-course-btns">
              <ul class="nav">
                <li>
                  <button
                    @click="handleNewUser"
                    class="btn btn-success-dark"
                  >
                    <i class="bx bx-user-plus"></i> Novo Usuário
                  </button>
                </li>
                <li>
                  <router-link to="/caduceus/dashboard" class="btn btn-black">
                    Voltar
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtros -->
      <div class="row" style="margin-top: 20px;">
        <div class="col-md-12">
          <div class="card">
            <div class="widget-set">
              <div class="widget-content">
                <div class="add-course-form">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="add-course-label">Pesquisar por Nome ou Email</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Digite nome ou email para pesquisar"
                          v-model="searchQuery"
                          @keyup.enter="handleSearch"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group" style="padding-top: 30px;">
                        <button
                          @click="handleSearch"
                          class="btn btn-primary me-2"
                          :disabled="loading"
                        >
                          <i class="bx bx-search"></i> Pesquisar
                        </button>
                        <button
                          @click="handleClear"
                          class="btn btn-secondary"
                          :disabled="loading"
                        >
                          <i class="bx bx-x"></i> Limpar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabela de Usuários -->
      <div class="row" style="margin-top: 20px;">
        <div class="col-md-12">
          <div class="card">
            <div class="widget-set">
              <div class="widget-content">
                <div v-if="loading" class="text-center p-4">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Carregando...</span>
                  </div>
                </div>
                <div v-else-if="users.length === 0" class="text-center p-4">
                  <p>Nenhum usuário encontrado.</p>
                </div>
                <div v-else class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Telefone</th>
                        <th>Função</th>
                        <th>Cursos</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in users" :key="user.id">
                        <td>{{ user.id }}</td>
                        <td>{{ user.fullName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone || user.mobilePhone || '-' }}</td>
                        <td>{{ user.function || '-' }}</td>
                        <td>
                          <span
                            v-if="user.enrollments && user.enrollments.length > 0"
                            class="badge bg-success"
                          >
                            {{ user.enrollments.length }} curso(s)
                          </span>
                          <span v-else class="badge bg-secondary">Nenhum curso</span>
                        </td>
                        <td>
                          <button
                            @click="handleEdit(user)"
                            class="btn btn-sm btn-primary"
                          >
                            <i class="bx bx-edit"></i> Editar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginação -->
      <div class="row" v-if="pagination.totalPages > 1" style="margin-top: 20px;">
        <div class="col-md-12">
          <div class="dash-pagination">
            <div class="row align-items-center">
              <div class="col-6">
                <p>
                  Página {{ pagination.page }} de {{ pagination.totalPages }} (Total: {{ pagination.total }} usuários)
                </p>
              </div>
              <div class="col-6">
                <ul class="pagination">
                  <li :class="{ disabled: pagination.page === 1 }">
                    <a
                      href="javascript:void(0);"
                      @click="changePage(pagination.page - 1)"
                    >
                      <i class="bx bx-chevron-left"></i>
                    </a>
                  </li>
                  <li
                    v-for="page in visiblePages"
                    :key="page"
                    :class="{ active: page === pagination.page }"
                  >
                    <a
                      href="javascript:void(0);"
                      @click="changePage(page)"
                    >
                      {{ page }}
                    </a>
                  </li>
                  <li :class="{ disabled: pagination.page === pagination.totalPages }">
                    <a
                      href="javascript:void(0);"
                      @click="changePage(pagination.page + 1)"
                    >
                      <i class="bx bx-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Edição -->
  <div
    v-if="showEditModal"
    class="modal fade show"
    style="display: block;"
    tabindex="-1"
    @click.self="closeEditModal"
  >
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar Usuário</h5>
          <button
            type="button"
            class="btn-close"
            @click="closeEditModal"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleUpdate">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="add-course-label">Email *</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="editForm.email"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="add-course-label">Nome Completo *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.fullName"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="add-course-label">Telefone</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.phone"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="add-course-label">Função</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.function"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="add-course-label">Cursos (Seleção Múltipla)</label>
                  <div v-if="loadingCourses" class="text-muted">
                    Carregando cursos...
                  </div>
                  <div v-else-if="courses.length === 0" class="text-muted">
                    Nenhum curso disponível
                  </div>
                  <div v-else class="course-selection">
                    <div
                      v-for="course in courses"
                      :key="course.id"
                      class="form-check mb-2"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="course.id"
                        :id="`edit-course-${course.id}`"
                        v-model="editForm.courseIds"
                      />
                      <label
                        class="form-check-label"
                        :for="`edit-course-${course.id}`"
                      >
                        {{ course.title }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeEditModal"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleUpdate"
            :disabled="saving"
          >
            <span
              v-if="saving"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            {{ saving ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showEditModal" class="modal-backdrop fade show"></div>

  <layouts1></layouts1>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import Swal from 'sweetalert2';

const router = useRouter();

const title = ref('Usuários');
const text = ref('Home');
const text1 = ref('Usuários');

const users = ref([]);
const loading = ref(false);
const loadingCourses = ref(false);
const saving = ref(false);
const searchQuery = ref('');
const currentSearch = ref('');
const pagination = ref({
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
});

const showEditModal = ref(false);
const courses = ref([]);
const editForm = ref({
  id: null,
  email: '',
  fullName: '',
  phone: '',
  function: '',
  courseIds: [],
});

const visiblePages = computed(() => {
  const total = pagination.value.totalPages;
  const current = pagination.value.page;
  const pages = [];
  
  if (total <= 7) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    if (current <= 4) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total);
    } else if (current >= total - 3) {
      pages.push(1);
      pages.push('...');
      for (let i = total - 4; i <= total; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total);
    }
  }
  
  return pages;
});

const fetchUsers = async () => {
  loading.value = true;
  try {
    const params = {
      page: pagination.value.page,
      limit: pagination.value.limit,
    };
    
    if (currentSearch.value) {
      params.search = currentSearch.value;
    }

    const response = await ApiService.get('/users/admin/list', params);
    users.value = response.data.users || [];
    pagination.value = {
      ...pagination.value,
      total: response.data.pagination.total,
      totalPages: response.data.pagination.totalPages,
    };
  } catch (error) {
    console.error('Error fetching users:', error);
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Erro ao carregar usuários. Por favor, tente novamente.'
    });
  } finally {
    loading.value = false;
  }
};

const fetchCourses = async () => {
  loadingCourses.value = true;
  try {
    const response = await ApiService.get('/courses/me');
    courses.value = response.data || [];
  } catch (err) {
    console.error('Error fetching courses:', err);
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Erro ao carregar cursos. Por favor, tente novamente.'
    });
  } finally {
    loadingCourses.value = false;
  }
};

const handleSearch = () => {
  currentSearch.value = searchQuery.value.trim();
  pagination.value.page = 1;
  fetchUsers();
};

const handleClear = () => {
  searchQuery.value = '';
  currentSearch.value = '';
  pagination.value.page = 1;
  fetchUsers();
};

const changePage = (page) => {
  if (page >= 1 && page <= pagination.value.totalPages && page !== pagination.value.page) {
    pagination.value.page = page;
    fetchUsers();
  }
};

const handleEdit = (user) => {
  editForm.value = {
    id: user.id,
    email: user.email,
    fullName: user.fullName,
    phone: user.phone || user.mobilePhone || '',
    function: user.function || '',
    courseIds: user.enrollments ? user.enrollments.map(e => e.courseId) : [],
  };
  showEditModal.value = true;
  if (courses.value.length === 0) {
    fetchCourses();
  }
};

const closeEditModal = () => {
  showEditModal.value = false;
  editForm.value = {
    id: null,
    email: '',
    fullName: '',
    phone: '',
    function: '',
    courseIds: [],
  };
};

const handleUpdate = async () => {
  if (!editForm.value.email || !editForm.value.fullName) {
    Swal.fire({
      icon: 'warning',
      title: 'Validação',
      text: 'Email e Nome completo são obrigatórios'
    });
    return;
  }

  saving.value = true;
  try {
    const payload = {
      email: editForm.value.email.trim(),
      fullName: editForm.value.fullName.trim(),
      courseIds: editForm.value.courseIds || []
    };

    if (editForm.value.phone && editForm.value.phone.trim()) {
      payload.phone = editForm.value.phone.trim();
    }

    if (editForm.value.function && editForm.value.function.trim()) {
      payload.function = editForm.value.function.trim();
    }

    await ApiService.put(`/users/admin/${editForm.value.id}`, payload);

    Swal.fire({
      icon: 'success',
      title: 'Sucesso!',
      text: 'Usuário atualizado com sucesso!',
      confirmButtonText: 'OK'
    });

    closeEditModal();
    fetchUsers();
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      'Erro ao atualizar usuário. Por favor, tente novamente.';
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: errorMessage
    });
  } finally {
    saving.value = false;
  }
};

const handleNewUser = () => {
  router.push('/caduceus/admin/users/create');
};

onMounted(() => {
  fetchUsers();
});
</script>

<style scoped>
.course-selection {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
}

.form-check {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-check:last-child {
  border-bottom: none;
}

.form-check-label {
  margin-left: 8px;
  cursor: pointer;
}

.modal {
  z-index: 1050;
}

.modal-backdrop {
  z-index: 1040;
}

.pagination li.disabled a {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
